import { NavLink } from "react-router-dom"
import "./styles/Navbar.css"
import logoFanttech from './assets/images/Logo Fanttech.png';

function Navbar() {
    return (
        <div className="navbar-flex-container">
            <NavLink className="navbar-logo" to="/">
                <img className="navbar-img" src={logoFanttech} alt=""/>
            </NavLink>
            <NavLink className="navbar-btn" to="/solucoes">Soluções</NavLink>
            <NavLink className="navbar-btn" to="/sobre">Sobre</NavLink>
            <NavLink className="navbar-btn" to="/parceiros">Parceiros</NavLink>
            <NavLink className="navbar-btn" to="/contato">Contato</NavLink>
            <NavLink className="navbar-btn" to="/portal/home">Portal</NavLink>
        </div>
    )
    /*return (
        <Link className="navbar-logo" to="/">
                <img className="navbar-img" src="../public/assets/images/Logo Fanttech.png" />
            </Link>
            <Link className="navbar-btn" to="/solucoes">Soluções</Link>
            <Link className="navbar-btn" to="/sobre">Sobre</Link>
            <Link className="navbar-btn" to="/parceiros">Parceiros</Link>
            <Link className="navbar-btn" to="/contato">Contate-nos</Link>
            <Link className="navbar-btn" to="/portal/home">Portal</Link>
    )*/
}

export default Navbar
